/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '';
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'https://xmc-childrensho3e59-cw60b4-prod2126.sitecorecloud.io';
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || 'giving';
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge';
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en';
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'https://xmc-childrensho3e59-cw60b4-prod2126.sitecorecloud.io/sitecore/api/graph/edge';
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss';
config.publicUrl = process.env.PUBLIC_URL || 'https://giving.childrenswi.org';
config.sitecoreSearchEnv = process.env.SITECORE_SEARCH_ENV || 'prodEu';
config.sitecoreSearchCustomerKey = process.env.SITECORE_SEARCH_CUSTOMER_KEY || '';
config.sitecoreSearchApiKey = process.env.SITECORE_SEARCH_API_KEY || '';
config.sitecoreEdgeUrl = process.env.SITECORE_EDGE_URL || 'https://edge-platform.sitecorecloud.io';
config.sitecoreEdgeContextId = process.env.SITECORE_EDGE_CONTEXT_ID || 'eEcSXIP2ail10pZ926PaT';
config.sites = process.env.SITES || '[{"name":"Shared","hostName":"*","language":"en"},{"name":"childrens","hostName":"childrenswi.org","language":"en"},{"name":"giving","hostName":"giving-prod.vercel.app","language":"en"}]';
module.exports = config;